/*
 * Takes a video URL, wraps it in a instance of our default modal
 * and opens it when the user hits play
 *
 * Only supports YouTube embeds right now
 */
import MicroModal from 'micromodal'
import { createModal } from '../library/Modal'
import { createVideo } from '../library/VideoPlayer'

export default class VideoModal {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.embed = this.el.dataset.embed
    this.style = 'modal__video'
    this.heading = false
    this.footer = false
    this.id = this.el.dataset.id
  }

  handleClick(event) {
    event.preventDefault()

    // Check if the element is inside a Carousel module and if
    // it has a dragging class, bail on the handleClick function
    const carousel = this.el.closest('[data-module="Carousel"]')
    if (carousel && carousel.classList.contains('is-dragging')) {
      return
    }
    MicroModal.show(this.id, {
      onShow: () => {
        // improve autoplay: https://github.com/sampotts/plyr/issues/2079#issuecomment-1192611487
        this.video.player.currentTime = 0
        this.video.player.play()
      },
      onClose: () => {
        this.video.player.pause()
      },
    })
  }

  init() {
    const modal = createModal(this.id, {
      style: 'modal__video',
      hasHeading: this.heading,
      hasFooter: this.footer,
    })
    const content = modal.querySelector('.modal__content')
    // this returns the wrapping element and the instance of
    // the player
    this.video = createVideo(this.embed)
    content.appendChild(this.video.wrapper)
    this.el.removeEventListener('click', this.handleClick.bind(this)) // Remove any existing event listeners
    this.el.addEventListener('click', this.handleClick.bind(this))
  }
}
